/* Hand-drawn circle that draws itself around the footer "here" link on
   hover. Ported from https://codepen.io/spencerthayer/pen/nhjwu to plain
   JS (the theme ships no jQuery) and scoped to the footer contact link.

   How it works: an SVG sits over the word, holding one wobbly, slightly
   random circle path. The path's dash pattern is one dash the length of
   the path followed by a gap twice that long; at rest the offset parks
   the path in the middle of the gap, so the stroke is fully hidden with
   half a path-length of safety margin on either side (an offset sitting
   exactly on the dash boundary let rounding poke a sliver of stroke out
   — the "always visible line" bug). On hover, CSS transitions the
   offset to 0, which "draws" the circle in one continuous stroke. A
   fresh random path is generated on each hover so the circle is never
   drawn quite the same way twice, like a real pen mark. */
(function () {
  var NS = 'http://www.w3.org/2000/svg';

  /* Generates a rough closed circle as an SVG path string, with tunable
     randomness in radius and angle. Straight from the CodePen. */
  function circlePath(drMin, drMax, t0Min, t0Max, dtMin, dtMax) {
    var c = 0.551915024494,
      beta = Math.atan(c),
      d = Math.sqrt(c * c + 1),
      r = 0.9,
      theta = ((t0Min + Math.random() * (t0Max - t0Min)) * Math.PI) / 180,
      path = 'M' + [r * Math.sin(theta), r * Math.cos(theta)];

    path += ' C' + [d * r * Math.sin(theta + beta), d * r * Math.cos(theta + beta)];

    for (var i = 0; i < 4; i++) {
      theta += (Math.PI / 2) * (1 + dtMin + Math.random() * (dtMax - dtMin));
      r *= 1 + drMin + Math.random() * (drMax - drMin);
      path += ' ' + (i ? 'S' : '') + [d * r * Math.sin(theta - beta), d * r * Math.cos(theta - beta)];
      path += ' ' + [r * Math.sin(theta), r * Math.cos(theta)];
    }
    return path;
  }

  function build(marker) {
    if (marker.dataset.tutiMarker) return;
    marker.dataset.tutiMarker = '1';
    marker.classList.add('tuti-marker');

    var svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('viewBox', '-1 -1 2 2');
    /* The viewBox is square but the rendered box is wider than tall
       (the word's shape). Without this, the default xMidYMid scaling
       keeps the drawing round — a small perfect circle floating over
       the word. 'none' stretches it into the oval that actually wraps
       the word; non-scaling-stroke on the path keeps the line width
       even despite the stretch. */
    svg.setAttribute('preserveAspectRatio', 'none');
    svg.setAttribute('class', 'tuti-marker__svg');
    svg.setAttribute('aria-hidden', 'true');
    marker.appendChild(svg);

    var path = document.createElementNS(NS, 'path');
    path.setAttribute('vector-effect', 'non-scaling-stroke');
    svg.appendChild(path);

    /* Size the SVG a little larger than the word so the loop clears it
       on every side, and let the circle become an oval matching that
       box. Inline styles, not attributes: the theme's base.css puts
       max-width: 100% on every svg (which squashed the oval back to
       the word's width — a near-square box that rendered as a circle),
       and another theme rule sets svg widths; inline wins over both.
       Centring is done in CSS. Re-run on resize because the heading is
       fluid, and on fonts.ready because the word grows when the web
       font swaps in. */
    function resize() {
      var w = marker.offsetWidth;
      var h = marker.offsetHeight;
      if (!w || !h) return;
      svg.style.width = Math.round(w * 1.6) + 'px';
      svg.style.height = Math.round(h * 1.5) + 'px';
      svg.style.maxWidth = 'none';
    }

    /* With vector-effect: non-scaling-stroke, dash lengths are applied
       in SCREEN pixels, not path units — so the dash math must use the
       path's rendered on-screen length. getTotalLength() returns the
       tiny user-unit length (~6), which produced a 6px dash repeating
       around the whole loop: the permanently visible dashed line.
       The viewBox is 2x2 stretched to the svg's box, so sample the
       path and scale each segment by the box's half-size per axis. */
    function renderedLength() {
      var lu = path.getTotalLength();
      var sx = (parseFloat(svg.style.width) || 0) / 2;
      var sy = (parseFloat(svg.style.height) || 0) / 2;
      if (!sx || !sy || !lu) return 0;
      var N = 64;
      var prev = path.getPointAtLength(0);
      var L = 0;
      for (var i = 1; i <= N; i++) {
        var pt = path.getPointAtLength((lu * i) / N);
        L += Math.hypot((pt.x - prev.x) * sx, (pt.y - prev.y) * sy);
        prev = pt;
      }
      return L;
    }

    /* New random circle, parked just past the dash boundary: hidden, but
       only barely. CSS :hover transitions the offset to 0 to draw it.

       The offset has to fall below one path-length before any stroke
       shows, so every bit of travel above that is dead time on hover.
       Parking at 1.5x (mid-gap) spent a third of the animation drawing
       nothing, which read as lag before the pen appeared. 1.05x keeps a
       0.05-length margin either side — enough that rounding cannot poke
       a sliver of stroke out, which is what an offset sitting exactly on
       the boundary used to do — while cutting the dead travel to ~5%.

       Attributes, not inline styles, so the :hover CSS rule can
       override them. */
    function redraw() {
      path.setAttribute('d', circlePath(-0.15, 0.05, 150, 190, 0.05, 0.3));
      var len = renderedLength();
      if (!len) return;
      path.setAttribute('stroke-dasharray', len + ' ' + 2 * len);
      path.setAttribute('stroke-dashoffset', 1.05 * len);
    }

    /* For everything except the hover draw itself: swap the state with
       the transition suppressed, so page load / font swap / resize
       never flash a partially drawn stroke. */
    function redrawInstant() {
      path.style.transition = 'none';
      resize();
      redraw();
      void path.getBoundingClientRect(); // commit before re-enabling
      path.style.transition = '';
    }

    redrawInstant();
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(redrawInstant);
    }
    marker.addEventListener('mouseenter', redraw);
    marker.addEventListener('focus', redraw);
    window.addEventListener('resize', redrawInstant);
  }

  function init() {
    document
      .querySelectorAll('[class*="__text_LWt8Pz"] a[href="/pages/contact"]')
      .forEach(build);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
